import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import dayjs from 'dayjs';
import { getCurrentRewardRecords } from '@/apis/casino/rush';
import { useQuery } from '@tanstack/react-query';

const RoundHistoryTable: React.FC = () => {
  const rows = [
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100053',
      userName: 'Minyo',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: '73f429be10dd4beab70ff9dc548946333b031b8bdff1fe5855440ee0cd343bb9',
      result: '0.452944382574846177',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T21:01:22.887Z',
    },
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100186',
      userName: 'wick0x01',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: '5fcbad076b85cfd9d6ce8923280374cc2092b2ecdc7f5543bca3dbaf05ca8e96',
      result: '0.374201597510839451',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T13:19:11.407Z',
    },
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100186',
      userName: 'wick0x01',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: 'd4088eca1cf0fce7161d4dd85eaa288b89f799b4b43510b7272d8884feda7d94',
      result: '0.828255581230170110',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T13:19:07.815Z',
    },
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100186',
      userName: 'wick0x01',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: 'da60384ee47d3720f7325fea986472f058120cafb8461e914c9c04bdbe0754b4',
      result: '0.853030699978707257',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T13:19:04.127Z',
    },
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100186',
      userName: 'wick0x01',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: '7e07d43fb743f97d9796428c401fed7729800b2ee730e7be0b3ae573ba04814b',
      result: '0.492306962543139437',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T13:19:01.163Z',
    },
    {
      gameId: 'rush',
      roundId: '270',
      uid: '100186',
      userName: 'wick0x01',
      amountType: 1,
      amount: '1',
      rewardType: 6,
      payout: '0',
      multiplier: '0.0',
      hash: '9ae75594415a83f69575d9ac347ae43bb7b091d44bd59f0e4b4df9194f9d2bc8',
      result: '0.605092381186617373',
      currency: 'USDT',
      currencyInfo: {
        id: 1,
        name: 'usdt',
        symbol: 'usdt',
        decimals: 6,
      },
      createdTime: '2023-11-14T13:18:58.178Z',
    },
  ];
  const [list, setList] = useState<any[]>([...rows]);

  const { isLoading, error } = useQuery({
    queryKey: ['CrashLatestFive'],
    queryFn: async () =>
      getCurrentRewardRecords({
        currentPage: 1,
        pageSize: 5,
      }),
    onSuccess: (res) => {
      if (res.status.code === '0') {
        setList(res.data.records);
      }
    },
  });

  const { t } = useTranslation();

  return (
    <>
      <TableContainer component={Box}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t('Date/Time')}</TableCell>
              <TableCell align="left">{t('Result')}</TableCell>
              <TableCell align="left">{t('Round')}</TableCell>
              <TableCell align="left">{t('Hash')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{ whiteSpace: 'no-wrap' }}
                  component="th"
                  scope="row"
                >
                  {dayjs(row.createdTime).format('MMMM D YYYY h:mm A')}
                </TableCell>
                <TableCell align="left">x{row.multiplier}</TableCell>
                <TableCell align="left">{row.roundId}</TableCell>
                <TableCell align="left">{row.hash}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RoundHistoryTable;
